"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = void 0;
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
const axios_1 = __importDefault(require("axios"));
class AuthService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.authToken = async (user) => {
            const URL = `${environment_1.API_URL_AUTH_TOKEN}/${this.ENV}/users/auth`;
            const response = await axios_1.default.post(URL, JSON.stringify(user), { headers: { 'x-api-key': this.API_KEY } });
            return Promise.resolve(response.data);
        };
        this.refreshToken = async (user) => {
            const URL = `${environment_1.API_URL_AUTH_TOKEN}/${this.ENV}/users/auth/refresh`;
            const response = await axios_1.default.post(URL, JSON.stringify(user), { headers: { 'x-api-key': this.API_KEY } });
            return response.data;
        };
        this.API_KEY = key;
        this.ENV = ENV;
    }
}
exports.AuthService = AuthService;
